import { Button } from "antd";
import { ReactNode } from "react";
import CloseIcon from "../../assets/icons/CloseIcon";

interface ModalCustomTitleType {
  icon: ReactNode;
  iconClassName: string;
  title: string;
  handleClose: () => void;
}

export default function ModalCustomTitle({
  title,
  icon,
  handleClose,
  iconClassName,
}: ModalCustomTitleType) {
  return (
    <div className="flex items-center gap-2 mb-6">
      <Button
        className={`middle-button !border-none disabled:!cursor-auto ${iconClassName}`}
        icon={icon}
        disabled
      />
      <h3 className="text-header text-[22px] font-semibold">{title}</h3>
      <div className="flex-1 flex justify-end">
        <button
          className="middle-button !text-display-medium border-none"
          onClick={handleClose}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}
